// Enums

export enum TipoOperacaoDeEstoque {
  ENTRADA = 'ENTRADA',
  SAIDA = 'SAIDA'
}

export enum TipoContaEstoque {
  NORMAL = 'NORMAL',
  ECOMMERCE = 'ECOMMERCE'
}

// Formato serializado pelo backend (LocalizableEnumSerializer)
// O backend serializa enums LocalizableEnum como objeto { enum, nome, id, descricao }
export interface LocalizableEnumDTO {
  enum: string;
  nome: string;
  id?: number;
  descricao?: string;
}

// DTO para API (reflete o JSON do backend - AjusteDeEstoqueDTO.kt)
export interface AjusteDeEstoqueDTO {
  id?: number;
  codigoAjusteDeEstoque?: number;
  // O backend serializa como objeto { enum: "ENTRADA", nome: "Entrada", ... }
  tipoOperacaoDeEstoque: TipoOperacaoDeEstoque | LocalizableEnumDTO;
  item_id?: number;
  quantidade: number;
  emissao: string; // ISO 8601 LocalDateTime
  saldoAnterior?: number;
  saldo?: number;
  empresaId?: number;
  criadoEm?: string;
  atualizadoEm?: string;
  usuarioDeAdicao?: number;
  usuarioDeUltimaAlteracao?: number;
  tipoContaEstoque: TipoContaEstoque;
}

// FormDTO para formularios (com { label, value } para dropdowns)
export interface AjusteDeEstoqueFormDTO {
  tipoOperacaoDeEstoque: { label: string; value: TipoOperacaoDeEstoque } | undefined;
  quantidade: number | undefined;
  tipoContaEstoque: { label: string; value: TipoContaEstoque } | undefined;
}

// ResponseDTO para paginacao
export interface AjusteDeEstoqueResponseDTO {
  content: AjusteDeEstoqueDTO[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
}
